import './App.css';

function App() {
  return (
    <div className="App">
      <header className="App-header">
        <div className="body">
          <h3>If you can see me, it works! Welcome to the new PE webapp</h3>
        </div>
      </header>
    </div>
  );
}

export default App;
